module.exports = __webpack_public_path__ + "img/R3_4_research_matsumoto.94ad5b26.png";